import type { PlayerUIModel } from "~/types/players.types";

export default function usePlayersDatabase() {
  async function fetchUsersPlayers(): Promise<PlayerUIModel[]> {
    try {
      const data = await usePrivateApiFetch()("/api/players/user");
      return data || [];
    } catch (error) {
      if (import.meta.client) {
        usePosthog().logError(error, "usePlayersDatabase:fetchUsersPlayers");
      }

      return [];
    }
  }

  async function getPlayerData(id: string): Promise<PlayerUIModel | undefined> {
    try {
      return await usePrivateApiFetch()(`/api/players/${id}`);
    } catch (error) {
      if (import.meta.client) {
        usePosthog().logError(error, "usePlayersDatabase:getPlayerData");
      }

      return undefined;
    }
  }

  async function editPlayer(
    id: string,
    playerData: Partial<PlayerUIModel>,
    options?: { confirmVerificationInvalidation?: boolean },
  ): Promise<PlayerUIModel> {
    return await $fetch<PlayerUIModel>(`/api/players/${id}`, {
      method: "PUT",
      body: {
        ...playerData,
        ...(options?.confirmVerificationInvalidation
          ? { confirmVerificationInvalidation: true }
          : {}),
      },
    });
  }

  async function createPlayer(
    playerData: Partial<PlayerUIModel>,
  ): Promise<PlayerUIModel> {
    return await $fetch<PlayerUIModel>("/api/players", {
      method: "POST",
      body: playerData,
    });
  }

  async function deletePlayer(id: string): Promise<void> {
    await $fetch(`/api/players/${id}`, {
      method: "DELETE",
    });
  }

  async function removePlayerFromGym(id: string): Promise<void> {
    await $fetch(`/api/players/${id}/remove-from-gym`, {
      method: "POST",
    });
  }

  return {
    fetchUsersPlayers,
    getPlayerData,
    createPlayer,
    editPlayer,
    deletePlayer,
    removePlayerFromGym,
  };
}
